/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import BaseService from '../../../services/BaseService';
import { ChartCard } from '../RelatorioDigitacao/chartShared';
import ChartFocusDialog from '../RelatorioDigitacao/ChartFocusDialog';
import PeriodoHistoricoChart from './PeriodoHistoricoChart';
import {
  EMPTY_PERIODO_HISTORICO,
  HISTORICO_SEMANAS_DEFAULT,
  buildHistoricoFilterForApi,
  normalizePeriodoHistorico,
} from './constants';

const FOCUS_HEIGHT = 520;

const PeriodoHistoricoSection = ({
  localFilter,
  refreshKey,
  onItemsLoaded,
}) => {
  const [data, setData] = useState(EMPTY_PERIODO_HISTORICO);
  const [loading, setLoading] = useState(false);
  const [focusOpen, setFocusOpen] = useState(false);
  const [historicoSemanas, setHistoricoSemanas] = useState(HISTORICO_SEMANAS_DEFAULT);
  const onItemsLoadedRef = useRef(onItemsLoaded);
  onItemsLoadedRef.current = onItemsLoaded;

  const title = `Evolução (últimas ${historicoSemanas} semanas)`;

  const apiFilter = useMemo(
    () => buildHistoricoFilterForApi(localFilter, historicoSemanas),
    [localFilter, historicoSemanas],
  );

  const fetchHistorico = useCallback(async () => {
    setLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/uso-mutuo/charts/by-period',
        data: apiFilter,
      });
      const next = normalizePeriodoHistorico(response?.data);
      setData(next);
      onItemsLoadedRef.current?.(next.items);
    } catch {
      setData(EMPTY_PERIODO_HISTORICO);
      onItemsLoadedRef.current?.([]);
    } finally {
      setLoading(false);
    }
  }, [apiFilter, refreshKey]);

  useEffect(() => {
    fetchHistorico();
  }, [fetchHistorico]);

  const chartProps = {
    items: data.items,
    materialColumns: data.materialColumns,
    loading,
    historicoSemanas,
    onHistoricoSemanasChange: setHistoricoSemanas,
  };

  return (
    <>
      <ChartCard title={title} onExpand={() => setFocusOpen(true)} contentSx={{ pl: 1, pr: 2 }}>
        <PeriodoHistoricoChart {...chartProps} />
      </ChartCard>

      <ChartFocusDialog open={focusOpen} title={title} onClose={() => setFocusOpen(false)}>
        <PeriodoHistoricoChart {...chartProps} height={FOCUS_HEIGHT} />
      </ChartFocusDialog>
    </>
  );
};

PeriodoHistoricoSection.propTypes = {
  localFilter: PropTypes.object.isRequired,
  refreshKey: PropTypes.bool,
  onItemsLoaded: PropTypes.func,
};

PeriodoHistoricoSection.defaultProps = {
  refreshKey: false,
  onItemsLoaded: undefined,
};

export default PeriodoHistoricoSection;
